import React, { useState } from 'react';
import { Crown } from 'lucide-react';
import Template1 from './templates/Template1';
import Template2 from './templates/Template2';
import Template3 from './templates/Template3';
import Template4 from './templates/Template4';
import Template5 from './templates/Template5';
import Template6 from './templates/Template6';
import Template7 from './templates/Template7';
import Template8 from './templates/Template11';
import Template9 from './templates/Template9';
import Template10 from './templates/Template10';
import Template11 from './templates/Template8';
import Template12 from './templates/Template12';
import Template13 from './templates/Template13';
import Template14 from './templates/Template14';
import Template15 from './templates/Template15';
import Template16 from './templates/Template16';
import Template17 from './templates/Template17';
import Template18 from './templates/Template18';
import Template19 from './templates/Template19';
import Template20 from './templates/Template20';
import '../../styles/desktop/resume.css';

// 메인 컴포넌트
const LiveResumeTemplate = ({ resumeData, updatingField, language = 'kr', selectedTemplate = 1, showTemplateSelector = true, onTemplateChange }) => {
  const [currentTemplate, setCurrentTemplate] = useState(selectedTemplate);

  const templates = {
    1: Template1,
    2: Template2,
    3: Template3,
    4: Template4,
    5: Template5,
    6: Template6,
    7: Template7,
    8: Template8,
    9: Template9,
    10: Template10,
    11: Template11,
    12: Template12,
    13: Template13,
    14: Template14,
    15: Template15,
    16: Template16,
    17: Template17,
    18: Template18,
    19: Template19,
    20: Template20
  };

  const templateInfo = {
    // Premium Templates
    1: { name: '전문가', isPremium: true },
    2: { name: '블루미니멀', isPremium: true },
    4: { name: '신뢰', isPremium: true },
    5: { name: '투컬럼', isPremium: true },
    6: { name: '사이드바', isPremium: true },
    7: { name: '진중', isPremium: true },
    9: { name: '옐로우헤더', isPremium: true },
    10: { name: '블랙테마', isPremium: true },
    3: { name: '모던', isPremium: true },
    18: { name: '그레이', isPremium: true }, // 추가
    // Standard Templates
    8: { name: '전통형', isPremium: false },
    11: { name: '그린', isPremium: false },
    12: { name: '테이블', isPremium: false },
    13: { name: '클린', isPremium: false },
    14: { name: '골드', isPremium: false },
    15: { name: '블루', isPremium: false },
    16: { name: '사이드', isPremium: false },
    17: { name: '박스형', isPremium: false },
    19: { name: '심플', isPremium: false }, // 추가
    20: { name: '미니멀', isPremium: false } // 추가
  };

  const SelectedTemplate = templates[currentTemplate] || Template1;

  // 프리미엄과 일반 템플릿 분리
  const premiumTemplates = Object.keys(templateInfo).filter(key => templateInfo[key].isPremium);
  const standardTemplates = Object.keys(templateInfo).filter(key => !templateInfo[key].isPremium);

  return (
    <div>
      {/* 템플릿 선택 버튼 - showTemplateSelector가 true일 때만 표시 */}
      {showTemplateSelector && (
        <div className="template-selector print:hidden bg-white shadow-sm border-b border-gray-200" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
          <div className="pl-2 pr-4 pt-4 pb-3 space-y-2">
            {/* Premium Section */}
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-1.5 w-24">
                <span className="text-sm font-semibold text-gray-800">프리미엄</span>
                <Crown className="w-4 h-4 text-yellow-500" />
              </div>
              
              {/* Premium Templates */}
              <div className="flex flex-wrap gap-1.5">
                {premiumTemplates.map((templateKey) => (
                  <button
                    key={templateKey}
                    onClick={() => {
                      const newTemplateId = Number(templateKey);
                      setCurrentTemplate(newTemplateId);
                      if (onTemplateChange) {
                        onTemplateChange(newTemplateId);
                      }
                    }}
                    className={`px-3 py-1.5 text-xs rounded transition-all font-medium ${
                      currentTemplate === Number(templateKey) 
                        ? 'bg-amber-500 text-white shadow-sm hover:bg-amber-600' 
                        : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    {templateInfo[templateKey].name}
                  </button>
                ))}
              </div>
            </div>

            {/* Standard Section */}
            <div className="flex items-center gap-2">
              <div className="w-24">
                <span className="text-sm font-semibold text-gray-800">일반</span>
              </div>
              
              {/* Standard Templates */}
              <div className="flex flex-wrap gap-1.5">
                {standardTemplates.map((templateKey) => (
                  <button
                    key={templateKey}
                    onClick={() => {
                      const newTemplateId = Number(templateKey);
                      setCurrentTemplate(newTemplateId);
                      if (onTemplateChange) {
                        onTemplateChange(newTemplateId);
                      }
                    }}
                    className={`px-3 py-1.5 text-xs rounded transition-all font-medium ${
                      currentTemplate === Number(templateKey) 
                        ? 'bg-amber-500 text-white shadow-sm hover:bg-amber-600' 
                        : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    {templateInfo[templateKey].name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 선택된 템플릿 렌더링 */}
      <div className="resume-wrapper">
        <SelectedTemplate 
          resumeData={resumeData} 
          updatingField={updatingField} 
          language={language} 
        />
      </div>
    </div>
  );
};

export default LiveResumeTemplate;